import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import TimeTrackTable from "./TimeTrackTable";
import TimeTrackErrors from "./TimeTrackErrors";

import ScreenTitle from "Components/ScreenTitle";
import TimeTrackIcon from "@mui/icons-material/TimerOutlined";

const TimeTracking = () => {
  const { t } = useTranslation();
  const [value, setValue] = useState("1");
  const handleTabsChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className="content">
      <Paper square elevation={8} className="contentPaper">
        <ScreenTitle
          title="Time tracking"
          class="masterdata"
          icon={
            <TimeTrackIcon
              viewBox="0 0 24 24"
              style={{ width: "1.8em", height: "1.8em" }}
            />
          }
        />
        <Box sx={{ width: "100%", typography: "body1" }}>
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
                className="tabPanel"
                onChange={handleTabsChange}
                variant="scrollable"
                scrollButtons="auto"
              >
                <Tab label={t("Errors")} value="1" />
                <Tab label={t("Person / Month")} value="2" />
              </TabList>
            </Box>
            <TabPanel value="1">
              <TimeTrackErrors />
            </TabPanel>
            <TabPanel value="2">
              <TimeTrackTable />
            </TabPanel>
          </TabContext>
        </Box>
      </Paper>
    </div>
  );
};

export default TimeTracking;
